import "@theme/front/init.scss";

import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";

import {initScroll} from "./front/scroll";
import {onScroll} from "./front/navbar";

// import "@/front/cookie";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	const navbar = $(".navbar");

	$(".navbar-toggler").off("click").on("click", function () {
		const isShown = $(this).hasClass("collapsed");

		if (isShown) {
			navbar.addClass("navbar-shown");
		} else {
			navbar.removeClass("navbar-shown");
		}
	});

	initScroll();
	onScroll();

	window.addEventListener("scroll", function () {
		onScroll();
	});

	if (window.innerWidth <= 992) {
		$(".slide").css("height", window.innerHeight);
	}
});
